import api from './api';
import endpoints from './endpoints';

const attachmentService = {
  getAttachments: async (params = {}) => {
    return api.get(endpoints.attachments.list, { params });
  },

  getAttachment: async (id) => {
    return api.get(endpoints.attachments.detail(id));
  },

  uploadAttachment: async (file, options = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', file.name);
    if (options.description !== undefined) {
      formData.append('description', options.description);
    }
    if (options.editable !== undefined) {
      formData.append('editable', options.editable);
    }
    formData.append('status', options.status || 'published');
    if (options.metadata) {
      formData.append('metadata', JSON.stringify(options.metadata));
    }

    return api.post(endpoints.attachments.upload, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateAttachment: async (id, updateData) => {
    const payload = {
      fields: updateData,
    };
    return api.put(endpoints.attachments.update(id), payload);
  },

  deleteAttachment: async (id) => {
    return api.delete(endpoints.attachments.delete(id));
  },

  searchAttachments: async (query, params = {}) => {
    return api.post(endpoints.attachments.search, {
      params: { ...params, q: query },
    });
  },

  downloadAttachment: async (id, token = null) => {
    const url = token
      ? `${endpoints.attachments.download(id)}?img_token=${token}`
      : endpoints.attachments.download(id);
    return api.get(url, { responseType: 'blob' });
  },
};

export default attachmentService;

